import { faPersonWalkingWithCane } from "@fortawesome/free-solid-svg-icons"
import { List, Map, Stack } from "immutable"

const getIceServerData = () => {
    const data = [
        {
            urls: ["turns:sip.batchdialer.com:443"],
            username: "servera",
            credential: "emi8uYhAemi8uYhA",
            credentialType: "password",
        },
    ]
    const servers = [...data].map(v => {
        var c = ""
        for (var i = v.credential.length - 1; i >= 0; i--) {
            c += v.credential[i]
        }
        v.credential = c
        return v
    })
    return servers
}

const data = {
    loading: 0,
    loader: false,
    page: "",
    softphone: Map({
        apiKey: null,
        auth: false,
        status: "",
        state: "",
        number: "",
        turn: null,
        iceServers: [],
        sipServers: [],
        sipCredentials: {},
        registered: false,
        error: null,
        show: false,
        dial: {},
        hangup: false,
        destroy: false,
        postbackURL: "",
    }),
    auth: Map({
        checked: false,
        authorized: false,
        token: "",
        user: Map({}),
        stack: Stack([]),
        error: "",
        timeOffset: false,
        sendjslogs: false,
        canAccessPausedClient: false,
        clientKycStatus: "",
        isClientLockedOrPaused: false,
        isImpersonating: false,
        title: "",
        permissions: {},
    }),
    users: Map({
        loaded: false,
        loading: false,
        loaderror: "",
        data: List([]),
        tree: List([]),
        filter: {
            role: null,
            filter: "",
        },
    }),
    tenants: Map({
        loaded: false,
        loading: false,
        loaderror: "",
        data: List([]),
    }),
    resellers: Map({
        loaded: false,
        loading: false,
        loaderror: "",
        data: List([]),
    }),
    clients: Map({
        loaded: false,
        loading: false,
        loaderror: "",
        data: List([]),
    }),
    agent: Map({
        contact: null,
        campaign: null,
        presence: null,
        presencechanged: null,
        connected: false,
        intercepted: false,
        intercepting: null,
    }),
    call: {},
    note: {
        value: "",
        modal: false,
        dispomodal: false,
    },
    chat: {
        open: false,
        activeButton: "team",
        createState: true,
        selectedConversation: null,
        conversations: [],
        notifications: 0,
        userId: null,
        newMessage: false,
        initialized: false,
        values: Map({}),
        users: [],
        value: "",
    },
    importStats: {
        show: false,
        fields: [],
    },
    presenceCounter: 0,
    checks: {
        latency: [],
        startTest: false,
        startAudioTest: false,
    },
    callIntelligence: {
        messages: [],
        diff: [],
        subscribed: false,
        userInitials: "",
        trial: false,
        transcriber: null,
    },
    options: {
        minimized: false,
        addonCallIntelligence: false,
        hangupOnClose: true,
    },
    dialParams: {},
}

export default data
